import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ViewInvoiceModal = ({ isOpen, payment, onClose }) => {
  if (!isOpen || !payment) return null;

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-background/80 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="relative w-full max-w-2xl bg-card rounded-xl elevation-2xl overflow-hidden border border-border max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-heading font-semibold text-foreground flex items-center gap-2">
              <Icon name="FileText" size={24} className="text-primary" />
              Invoice Details
            </h2>
            <button
              onClick={onClose}
              className="p-2 hover:bg-muted rounded-md transition-smooth"
              aria-label="Close modal"
            >
              <Icon name="X" size={20} className="text-muted-foreground" />
            </button>
          </div>

          <div className="space-y-6">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-sm text-muted-foreground">Invoice ID</p>
                <p className="text-base font-mono font-semibold text-foreground">{payment?.invoiceId}</p>
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Payment Date</p>
                <p className="text-base font-semibold text-foreground">{new Date(payment?.paymentDate)?.toLocaleDateString()}</p>
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Client Name</p>
                <p className="text-base font-semibold text-foreground">{payment?.clientName}</p>
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Plan</p>
                <p className="text-base font-semibold text-foreground">{payment?.plan}</p>
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Amount</p>
                <p className="text-lg font-bold text-foreground">₹{payment?.amount?.toLocaleString()}</p>
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Status</p>
                <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                  payment?.status === 'success' ? 'bg-success/10 text-success' : 'bg-destructive/10 text-destructive'
                }`}>
                  {payment?.status === 'success' ? 'Success' : 'Failed'}
                </span>
              </div>
            </div>

            <div className="pt-4 border-t border-border">
              <Button
                variant="default"
                size="lg"
                onClick={onClose}
                fullWidth
              >
                Close
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewInvoiceModal;